import { useSelector } from 'react-redux';
import { isAuthenticatedSelector, isAuthenticationCompleteSelector } from 'store/auth/selectors';

export const isUserLoggedIn = () => {
    const isAuthenticated = useSelector(isAuthenticatedSelector);
    const isComplete = useSelector(isAuthenticationCompleteSelector);

    return Boolean(isAuthenticated && isComplete);
};
